/* 需求卡片：https://console.cloud.baidu-int.com/devops/icafe/issue/BE-EOP-13275/show */
import {getParams} from '@/utils/util';
import {API_IS_ACTIVATED_NEW} from './isActivated';

// 老带薪活动涉及所有认证方式submit接口
export const API_NEED_ADD_NEW = {
    ...API_IS_ACTIVATED_NEW,
};

export function getAddNewParams() {
    const hashSeg = location.hash ? location.hash.split('?') : [];
    const search = hashSeg.length > 1 ? hashSeg[1] : '';
    if (!search) {
        return null;
    }
    const query: any = getParams(search);
    if (query && query.campaignId && query.invitationUserCode) {
        const {campaignId, invitationUserCode} = query;
        return {
            campaignInfo: {
                campaignId,
                invitationCode: invitationUserCode,
            },
        };
    }
    return null;
}


export function getAddNewParam(url: string) {
    const addNew = API_NEED_ADD_NEW[url];
    if (addNew) {
        const campaignInfo = getAddNewParams();
        return Promise.resolve(campaignInfo);
    }
    return Promise.resolve();
}
